import { render } from "./PetaSPKLU_.vue?vue&type=template&id=393f9382&scoped=true&ts=true"
import script from "./PetaSPKLU_.vue?vue&type=script&lang=ts"
export * from "./PetaSPKLU_.vue?vue&type=script&lang=ts"

import "./PetaSPKLU_.vue?vue&type=style&index=0&id=393f9382&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393f9382"]])

export default __exports__